import type { PathImages, PathImagesFilters } from '@cobliteam/api-lib/src/dashboard/camera/definitions/PathImages';
import { FaceIdRequester } from '@cobliteam/api-lib/src/dashboard/camera/FaceIdRequester';
import type { PageableContent, UUID } from '@cobliteam/common-types';
import { Environment } from '@cobliteam/react-environments';
import { keepPreviousData, type UseQueryOptions, useQuery } from '@tanstack/react-query';

const env = Environment.getInstance().getEnvironment();
const faceIdRequester = new FaceIdRequester({ host: env.herbieApiHost });

const useGetImages = (vehicleId: UUID, filters: PathImagesFilters, options?: Partial<UseQueryOptions<PageableContent<PathImages>>>) => {
  return useQuery({
    queryKey: ['images', vehicleId, filters],
    queryFn: () => faceIdRequester.getImages(vehicleId, filters),
    placeholderData: keepPreviousData,
    ...options,
  });
};

export { useGetImages };
